// apiClient is axios with added interceptors
import apiClient from "@/utils/api-client.js";
import { convertToNumber } from "@/utils/DateConverter";
import { convertDefault } from "@/utils/BodyFormatter";
import { getDisplayableRuleInfo } from "../utils/RuleFormatter";

export const actions = {
	async fetchScenario(context, { scenario, created }) { // scenario is the name of a scenario variable in the store(string)
		// gets scenario data from database
		try {
			console.log('print')
			let res;
			if (created === undefined) {
				res = await apiClient.get(`/api/scenario/${context.state.selectedLoanId}`);
			} else {
				const scenarioInfo = await context.state.compareOptions.find(o => o.created === created);
				const scenarioId = scenarioInfo.id;
				res = await apiClient.get(`/api/scenario/${context.state.selectedLoanId}/${scenarioId}`);
			}
			context.commit("setScenario", { scenario: scenario, data: res.data.scenario });
			context.commit("setIsLegacyLoan", { sceanrio: scenario, data: res.data.created });
			context.commit("setScenarioValid", scenario);
			context.commit("addDefaultOption", scenario);
			context.commit("setPassingCompFactorLength");
			// resetPersonas can be used to test access permissions. Removes manager from the local personas
			// TODO: set to be called only when being run outside of encompass i.e. when being run locally
			// context.commit("resetPersonas", scenario);
			// TODO: Should be handled by DB now. If date errors occur when fetching scenario add this back in
			// context.commit("dateToString", scenario);
		} catch (err) {
			console.log(err);
		}
	},

	async fetchScenarioTimes(context) {
		// gets the scenarioId and timeCreated for all of this loan's saved scenarios
		try {
			const res = await apiClient.get(`/api/scenarioTimes/${context.state.selectedLoanId}`);
			context.commit("setCompareOptions", res.data);
		} catch (err) {
			console.log(err);
		}
	},

	async fetchNewEncompassValues(context) {
		// gets the new scenario when QDU is selected a second time and replaces the old encompass values with new ones
		try {
			const res = await apiClient.get(`/api/scenario/${context.state.selectedLoanId}`);
			context.commit("setEncompassValues", res.data);
		} catch (err) {
			console.log(err)
		}
	},

	async storeRunScenario(context, {scenarioName}) {
		// calls QuickQuote API with data currently in the QDU inputs and updates the scenario with new results
		let message = "";
		try {
			console.log('print run scenario')
			const baseUrl = process.env.VUE_APP_QUICK_QUOTE_BASE_URL;
			// const baseUrl = undefined;
			// converts all date values to number of milliseconds
			const convertedFields = JSON.parse(JSON.stringify(context.state[scenarioName].fields));
			// converts any 'N/A' value to None
			const body = convertDefault(convertedFields);
			if (body["program"] === undefined) {
				throw new Error("\nNo program was selected.");
			}

			// if the credit report is found then evaluate at level 4 otherwise evaluate at level 3
			body["level"] = context.state[scenarioName].creditReportFound ? 3 : 3

			// if the user is in the beta group evaluate in beta mode otherwise don't
			body["beta"] = context.getters.userIsInBetaGroup(scenarioName) && context.state[scenarioName].runBetaRules ? true : false;
			console.log(body.beta);
			
			// call QuickQuote with the given body
			const res = await apiClient.post(`${baseUrl}/api/QuickQuote/`, body);
			
			const program = res.data.programs[0];
			
			const newResults = {
				failedRules: await context.dispatch("fixRules", { passing: false, rules: program.failedRules, scenarioName }),
				passedRules: await context.dispatch('fixRules', { passing: true, rules: program.passedRules, scenarioName }),
				adjustments: program.adjustments,
				failedCompensatingFactors: await context.dispatch("fixRules", { passing: false, rules: program.failedCompensatingFactors, scenarioName }),
				passedCompensatingFactors: await context.dispatch('fixRules', { passing: true, rules: program.passedCompensatingFactors, scenarioName })
			};
			// if there are no errors when running the scenario then it is set as run but not saved
			// this is only done if the scenario that was run is the HALO scenario
			// this allows for the scenario to be saved to the database
			if (scenarioName === 'haloScenario') {
				context.commit('setHasRun', true);
				context.commit('setSaved', false);
			}
			context.commit('toggleAnimation');
			context.commit('updateScenarioResults', { scenario: scenarioName, data: newResults });
			if (scenarioName === 'haloScenario') {
				context.commit("setPassingCompFactorLength");
			}
			message = "No Error";
		} catch (error) {
			console.log(error.response);
			if (error.response) {
				// if error is due to missing fields alerts the user of which field is missing
				if (error.response.data.errors) {
					for (let field of error.response.data.errors) {
						message += "\n" + field + ". ";
					}
				}
			} else {
				// if any odd error comes through displays error message for user
				message = error.message;
				console.log(message);
			}
		}
		return message;
	},

	async storeSaveScenario(context) {
		// saves scenario and result to db
		// converts date fields to milliseconds to be stored in the db
		let message = "";
		let variant = "";
		try {
			context.commit("setScenarioValid", 'haloScenario');
			const body = JSON.parse(JSON.stringify(context.state.haloScenario));
			// converts any date fields to number values in the req body
			body.fields = convertToNumber(body.fields);

			// if the credit report is found then evaluate at level 4 otherwise evaluate at level 3
			body["level"] = context.state.haloScenario.creditReportFound ? 4 : 3
			

			// saves the scenario and it's results in the db
			await apiClient.post(`/api/scenario/${context.state.selectedLoanId}`, body);
			context.commit("encompassSave");
			// if the save function in the encompass plugin did not execute successfully
			if (context.state.saveSuccess === false && window.location.hostname !== 'localhost') {
				message = "There was an error when writing to the CRSE.";
				variant = "danger";
			// if the save function in the encompass plugin was successfully executed or if it was not run due to the website being run locally
			} else {
				console.log('test');
				context.commit("setSaved", true);
				context.commit("updateScenarioTime", 'haloScenario');
				message = "Scenario saved successfully!";
				variant = "success";
			}
		} catch (err) {
			console.log(err.message);
			message = "There was an error when trying to save the scenario.";
			variant = "danger";
		}
		return { message, variant };
	},

	async checkChangeInExceptions(context) {
		// compares the newly run scenario and the most recently saved scenario to see if any values used in exceptions have changed
		try {
			await context.dispatch('fetchScenarioTimes');
			await context.dispatch('fetchScenario', { scenario: "compareScenario1", created: context.getters.getCompareOptionsTimes[0] })
			await context.commit('findChangesInExceptions');
		} catch (err) {
			console.log(err);
		}
	},

	// TODO: this no longer calls mutations so this could be moved to mutations
	fixRules(context, { passing, rules, scenarioName }) { // payload is {passing: Boolean, rules: Array of rules returned from QuickQuote, scenarioName: name of scenario variable}
		// adds missing attributes to rules returned from response
		const scenario = context.state[scenarioName];
		for (let rule of rules) {
			// sets the validity of each rule
			passing ? (rule["valid"] = true) : (rule["valid"] = false);

			// corrects field name and adds param attribute
			for (let field of rule.fields) {
				field = getDisplayableRuleInfo(field, scenario.fields, rule);
			}
		}
		return rules;
	},
};